import React from 'react';

const LanguageToggle = ({ language, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => onLanguageChange('th')}
        className={`px-4 py-2 rounded-md font-medium transition-colors ${
          language === 'th'
            ? 'bg-white text-blue-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-800'
        }`}
      >
        ไทย
      </button>
      <button
        onClick={() => onLanguageChange('en')}
        className={`px-4 py-2 rounded-md font-medium transition-colors ${
          language === 'en'
            ? 'bg-white text-blue-600 shadow-sm'
            : 'text-gray-600 hover:text-gray-800'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
